<app-content-box>
  <div class="options-container">
    <div class="filter-option">
      <label for="dateRangeInput">{{ labels.DATE_RANGE }}</label>
      <mat-form-field appearance="outline">
        <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker">
          <input
            id="dateRangeInput"
            matStartDate
            formControlName="start"
            [placeholder]="labels.DATE_RANGE_START"
          />
          <input
            matEndDate
            formControlName="end"
            [placeholder]="labels.DATE_RANGE_END"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <button
          *ngIf="dateRange.get('start')?.value || dateRange.get('end')?.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="clearDateRange()"
        >
          <mat-icon fontSet="fa" fontIcon="fa-close"></mat-icon>
        </button>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    <app-autocomplete-dropdown
      class="filter-option"
      [label]="labels.FILTER_PATIENT"
      [options]="allPatients"
      [displayWith]="displayPatientFn"
      (selectionChange)="onPatientSelectionChange($event)"
    ></app-autocomplete-dropdown>

    <app-autocomplete-dropdown
      class="filter-option"
      [label]="labels.FILTER_DOCTOR"
      [options]="allDoctors"
      [displayWith]="displayDoctorFn"
      (selectionChange)="onDoctorSelectionChange($event)"
    ></app-autocomplete-dropdown>

    <!--<app-autocomplete-dropdown
      class="filter-option"
      [label]="labels.STATUS"
      [options]="possibleStatus"
      [displayWith]="displayStatusFn"
      [multiple]="true"
      (selectionChange)="onStatusSelectionChange($event)"
    ></app-autocomplete-dropdown>

    <app-autocomplete-dropdown
      class="filter-option"
      [label]="labels.EXAM_URGENCY"
      [options]="possibleUrgency"
      [displayWith]="displayUrgencyFn"
      [multiple]="true"
      (selectionChange)="onUrgencySelectionChange($event)"
    ></app-autocomplete-dropdown>-->
  </div>
  <div
    class="list-container"
    *ngIf="requestList && requestList.length > 0; else emptyCase"
  >
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="sortData($event)"
    >
      <!-- Patient Name Column -->
      <ng-container matColumnDef="patient_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.PATIENT_NAME }}
        </th>
        <td mat-cell *matCellDef="let exam">
          {{ exam.patient !== null ? exam.patient?.name : labels.FROM_LIS }}
        </td>
      </ng-container>

      <!-- Exam Code Column -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.CODE }}
        </th>
        <td mat-cell *matCellDef="let exam">{{ exam.code || "-" }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.STATUS }}
        </th>
        <td mat-cell *matCellDef="let exam">
          <mat-chip-set class="status-chips">
            <mat-chip [ngClass]="exam.status">
              {{ getStatusLabel(exam.status) }}
            </mat-chip>
            <mat-chip *ngIf="isFromLis(exam)" [ngClass]="{'complete': exam.num_images_from_lis === exam.num_digitalized, 'incomplete': exam.num_images_from_lis !== exam.num_digitalized}">
              {{ getImageStatus(exam) }}
            </mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Urgency Column -->
      <ng-container matColumnDef="urgent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.URGENCY }}
        </th>
        <td mat-cell *matCellDef="let exam">
          <mat-chip-set>
            <mat-chip
              [ngClass]="['urgency-chip', exam.urgent ? 'true' : 'false']"
            >
              {{ getUrgencyLabel(exam.urgent) }}
            </mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- Non-Reads Column -->
      <ng-container matColumnDef="nonReads">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.NON_READS }}
        </th>
        <td mat-cell *matCellDef="let exam">
          {{ nonReads[dataSource.data.indexOf(exam)] }}
        </td>
      </ng-container>

      <!-- Assigned To Column -->
      <ng-container matColumnDef="assigned_to">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.ASSIGNED_TO }}
        </th>
        <td mat-cell *matCellDef="let exam">
          {{ exam.assigned_to?.full_name || "-" }}
        </td>
      </ng-container>

      <!-- Created At Column -->
      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.CREATED_AT }}
        </th>
        <td mat-cell *matCellDef="let exam">
          {{ exam.created_at | date: "yyyy-MM-dd HH:mm" }}
        </td>
      </ng-container>

      <!-- Finished At Column -->
      <ng-container matColumnDef="finished_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.FINISHED_AT }}
        </th>
        <td mat-cell *matCellDef="let exam">
          {{
            exam.finished_at
              ? (exam.finished_at | date: "yyyy-MM-dd HH:mm")
              : "-"
          }}
        </td>
      </ng-container>

      <!-- Operations -->
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ labels.ACTIONS }}
        </th>
        <td mat-cell *matCellDef="let exam">
          <div class="action-buttons">
            <i
              [class.disabled]="!allowEditOrDelete(exam)"
              [attr.disabled]="!allowEditOrDelete(exam) ? true : null"
              class="fas fa-pencil edit-btn"
              (click)="handleExamEdit(exam); $event.stopPropagation()"
              (keydown.enter)="handleExamEdit(exam); $event.stopPropagation()"
              tabindex="0"
              [matTooltip]="labels.EDIT_EXAM"
              [attr.aria-label]="labels.EDIT_EXAM"
            ></i>
            <i
              [class.disabled]="!allowEditOrDelete(exam)"
              [attr.disabled]="!allowEditOrDelete(exam) ? true : null"
              class="fas fa-trash delete-btn"
              (click)="confirmDelete(exam); $event.stopPropagation()"
              (keydown.enter)="confirmDelete(exam); $event.stopPropagation()"
              tabindex="0"
              [matTooltip]="labels.DELETE_EXAM"
              [attr.aria-label]="labels.DELETE_EXAM"
            ></i>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let exam; columns: displayedColumns"
        (click)="handleExamSelected(exam)"
        (keydown.enter)="handleExamSelected(exam)"
        tabindex="0"
      ></tr>
    </table>

    <span class="paginator-container" *ngIf="pageSize < count">
      <mat-paginator
        #paginator
        class="paginator"
        (page)="handlePageEvent($event)"
        [length]="count"
        [pageSize]="pageSize"
        [showFirstLastButtons]="showFirstLastButtons"
        [pageSizeOptions]="[]"
        [hidePageSize]="hidePageSize"
        [pageIndex]="pageIndex"
        aria-label="labels_paginators.PAGINATOR"
      >
      </mat-paginator>
    </span>
  </div>

  <ng-template #emptyCase>
    <div class="spinner-container" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!loading">
      {{ labels.NOEXAMREQUEST }}
    </div>
  </ng-template>
</app-content-box>
